module.exports = __webpack_public_path__ + "img/t_3.16669904.jpg";